<template>

    <div class="behavior-report-feedback-report-header">

        <h3 class="text-center">{{ $store.state.doc.data.cardTitle }}</h3>

        <table class="table name-rater">
            <tr>
                <td> <b>Student Name:</b> {{$store.state.doc.data.studentName}}</td>
                <td> <b>Rater:</b> {{ $store.state.doc.data.raterName }}</td>
            </tr>
        </table>

        <p>
            Directions: Review each of the Behavior Report Card items below.
            For each item, rate the degree to which the student showed the behavior or met the behavior goal.
        </p>

    </div>

</template>

<script>

    import Vue from 'vue'

    export default Vue.extend({
        name: "BehaviorReportFeedbackReportHeader",
    })

</script>

<style lang="scss">
    .behavior-report-feedback-report-header {
        margin-bottom: 15px;
        border-bottom: solid 1px #ddd;
        .name-rater {
            border-bottom: solid 1px #ddd;
        }
    }
</style>
